import { createContext, useCallback, useContext, useMemo, useState } from "react";

const EnquiryContext = createContext(null);

export const EnquiryProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [origin, setOrigin] = useState({ section: "", prefill: "" });

  const openEnquiry = useCallback((section, opts = {}) => {
    setOrigin({ section, prefill: opts.prefill || "", category: opts.category || null, context: opts.context || "", onReturn: opts.onReturn || null });
    setOpen(true);
  }, []);

  const value = useMemo(() => ({ open, setOpen, origin, openEnquiry }), [open, origin, openEnquiry]);
  return <EnquiryContext.Provider value={value}>{children}</EnquiryContext.Provider>;
};

export const useEnquiry = () => useContext(EnquiryContext);

const ATTR_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid", "msclkid", "src"];

export const captureAttribution = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const hasCampaign = ATTR_KEYS.some((k) => params.get(k));
    if (sessionStorage.getItem("alumicom_attr") && !hasCampaign) return;
    const attr = {};
    ATTR_KEYS.forEach((k) => { if (params.get(k)) attr[k] = params.get(k); });
    const ref = document.referrer;
    if (ref && !ref.startsWith(window.location.origin)) attr.referrer = ref;
    attr.landing_page = window.location.pathname;
    sessionStorage.setItem("alumicom_attr", JSON.stringify(attr));
  } catch (e) {
    // storage unavailable; attribution is optional
  }
};

export const readAttribution = () => {
  try {
    const a = JSON.parse(sessionStorage.getItem("alumicom_attr") || "{}");
    return a && typeof a === "object" ? a : {};
  } catch (e) {
    return {};
  }
};
